import { useEffect } from 'react';

// Escape-to-close + background scroll lock for a full-screen modal/dialog. Pair with
// <Portal> and role="dialog" aria-modal="true" on the overlay root.
//
// `active` defaults to true, which is correct for the common case where the parent only
// mounts the modal component while it's open (`{x && <Modal/>}`). Pass an explicit boolean
// for components that stay mounted and toggle their own overlay visibility internally
// (e.g. DemoWelcome) — otherwise the scroll lock would apply from first mount, not from
// when the overlay actually shows.
export function useModalA11y(onClose, active = true) {
  useEffect(() => {
    if (!active) return;
    const handleKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', handleKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose, active]);
}
